/**
 * i18n namespaces — one per backoffice module, so translations are maintained in
 * small focused files (`public/locales/<lng>/<ns>.json`) instead of one giant
 * catalog. Namespaces are loaded lazily, so a page only fetches the namespaces it
 * actually uses (plus `common`).
 *
 * Add a namespace here AND create its JSON under every `public/locales/<lng>/`
 * folder (English-filled at minimum — other languages fall back to English).
 */

/** Shared strings used across the whole app: nav, buttons, header, toasts. */
export const DEFAULT_NAMESPACE = "common";

/**
 * All namespaces the app knows about. Keep alphabetised after `common`.
 * All 10 supported locales are translated for every namespace, aside from a
 * few known pockets tracked as follow-up cleanup (see review notes on
 * `sports.json`, `users.json`, `common.json`) — not a wholesale English-only gap.
 */
// "forms" has a populated catalog but no current consumers (`useTranslation("forms")`
// appears nowhere in the app) — kept as reserved for an upcoming form-validation
// i18n pass rather than removed, since deleting it now would mean re-adding and
// re-populating the catalog later for no runtime benefit today.
export const NAMESPACES = ["bonus", "casino", "common", "dashboard", "finance", "forms", "lottery", "misc", "nav", "operators", "reports", "settings", "sports", "table", "users"] as const;

export type Namespace = (typeof NAMESPACES)[number];
